const SessionListActionTypeEnum = {
  DOCUMENT_SESSION_SELECT: 'DOCUMENT_SESSION_SELECT',
  DOCUMENT_SESSION_DESELECT: 'DOCUMENT_SESSION_DESELECT',
  DOCUMENT_SESSION_DESELECT_ALL: 'DOCUMENT_SESSION_DESELECT_ALL',
  DOCUMENT_SESSION_LIST_ADD: 'DOCUMENT_SESSION_LIST_ADD',
  DOCUMENT_SESSION_REMOVE: 'DOCUMENT_SESSION_REMOVE',
  DOCUMENT_SESSION_LIST_EDIT: 'DOCUMENT_SESSION_LIST_EDIT',
  DOCUMENT_SESSION_EXPAND: 'DOCUMENT_SESSION_EXPAND',

  DOCUMENT_SESSION_LIST_ITEM_ADD: 'DOCUMENT_SESSION_LIST_ITEM_ADD',
  DOCUMENT_SESSION_LIST_ITEM_UPDATE: 'DOCUMENT_SESSION_LIST_ITEM_UPDATE',
  DOCUMENT_SESSION_LIST_SEARCH_TERM_SET: 'DOCUMENT_SESSION_LIST_SEARCH_TERM_SET',
};

export const VISUAL_STATIC_DOCS = [
  '1099-misc-efile-2014',
  '1099-misc-efile-2015',
  '1099-misc-efile-2016',
  '1099-misc-efile-2017',
  '1099-misc-efile-2018',
  '1099-misc-efile-2019',
  '1099-misc-efile-2020',
  '1099-misc-efile-2021',
  '1099-misc-efile-2022',
  '1099-nec-efile-2020',
  '1099-nec-efile-2021',
  '1099-nec-efile-2022',
  'employee-paystub',
  'w2-efile-2014',
  'w2-efile-2015',
  'w2-efile-2016',
  'w2-efile-2017',
  'w2-efile-2018',
  'w2-efile-2019',
  'w2-efile-2020',
  'w2-efile-2021',
  'w2-efile-2022',
  'w9-2014-static',
];

export const DUPLICATE_ANIMATION_DURATION = 2500;

export default SessionListActionTypeEnum;



// WEBPACK FOOTER //
// ./src-react/SessionList/SessionListConstants.jsx